import {LineupTeamCombinationsMapInterface} from 'components/organisms/teams-combinations/lineup-team-combinations-map.interface';

export const createComboUnitId = (teamNames: string[]): string => teamNames.sort().join('-');

export function createLineupTeamCombinationsMap(rawLineups) {
    const map: LineupTeamCombinationsMapInterface = {
        lineups: {},
        combinations: {},
    };

    rawLineups.asArr().map((lineup) => {
        // @ts-ignore
        const lineupId = lineup.getId();
        const combinationId = createComboUnitId(lineup.getTeamNames());

        map.lineups[lineupId] ??= {};
        map.lineups[lineupId][combinationId] = true;

        map.combinations[combinationId] ??= {};
        map.combinations[combinationId][lineupId] = true;
    });

    return map;
}
